<template>
  <LoadingContainer :is-loading="false">
    <div class="card">
      <PaginatedListHeaderTemplate
        :total="items.length"
        :selections="[]"
        :has-selections="false"
        title="E-shop Home page"
      />
      <div class="card-content">
        <div class="columns">
          <div class="column is-full">
            <div class="table-wrapper">
              <table
                v-if="items.length"
                class="table is-bordered is-striped is-marginless is-fullwidth"
              >
                <thead>
                  <tr>
                    <th class="has-text-centered">#</th>
                    <th>Τίτλος</th>
                    <th>Περιγραφή</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="item.key">
                    <td class="has-text-centered">{{ index + 1 }}</td>
                    <td>
                      <router-link :to="item.to">
                        {{ item.title }}
                      </router-link>
                    </td>
                    <td>{{ item.description }}</td>
                  </tr>
                </tbody>
              </table>
              <h4 v-else class="title is-4 has-text-centered">
                Δε βρέθηκαν στοιχεία
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </LoadingContainer>
</template>

<script>
import PaginatedListHeaderTemplate from '@/views/components/PaginatedList/components/PaginatedListHeaderTemplate';
import LoadingContainer from '@/views/components/LoadingContainer';

export default {
  name: 'EshopHomepageIndex',
  components: {
    LoadingContainer,
    PaginatedListHeaderTemplate,
  },
  metaInfo: { title: 'E-shop Home page' },
  data: () => ({
    items: [
      {
        key: 'headerLinks',
        title: 'Header Links',
        description: 'Διαχείριση συνδέσμων στο header',
        to: { name: 'content.home.header-links.list' },
      },
      {
        key: 'banners',
        title: 'Banners',
        description: 'Διαχείριση banners αρχικής σελίδας',
        to: { name: 'content.home.banners.list' },
      },
      {
        key: 'productLists',
        title: 'Product Lists',
        description: 'Διαχείριση product lists (Λίστες προϊόντων)',
        to: { name: 'content.home.product-lists.list' },
      },
      {
        key: 'promoCards',
        title: 'Promo Card',
        description: 'Διαχείριση των promo cards (έως 2 ενεργές)',
        to: { name: 'content.home.promo-cards.list' },
      },
      {
        key: 'cardLinkLists',
        title: 'Card Link Lists',
        description: 'Διαχείριση card links (Λίστες και κάρτες)',
        to: { name: 'content.home.card-link-lists.list' },
      },
      {
        key: 'standaloneCards',
        title: 'Stand-alone Cards',
        description: 'Διαχείριση stand-alone cards',
        to: { name: 'content.home.standalone-cards.list' },
      },
    ],
  }),
};
</script>

<style scoped>
.table-wrapper {
  position: relative;
}
</style>
